import React from 'react';
import { bonuses } from '../data/resources';
import { IncludedTag } from './IncludedTag';
import { CoverPending } from './CoverPending';
export function Bonuses() {
  return <section aria-labelledby="bonus-title" className="bg-blush px-5 sm:px-8 py-16 sm:py-24" data-id="element-27" data-mp="av36mvbir927">
      <div className="max-w-6xl mx-auto" data-id="element-28" data-mp="at8tw4aein97">
        <div className="max-w-2xl" data-id="element-29" data-mp="ft4ojcx7l2c3">
          <h2 id="bonus-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-plum" data-id="element-30" data-mp="fsbn8rh0r51c">
            4 bonus per dare spazio alla tua creatività.
          </h2>
          <p className="mt-4 text-base sm:text-lg leading-relaxed text-ink/80" data-id="element-31" data-mp="5xbfi3ip7qz2">
            Idee di decorazione, portachiavi, penne e bomboniere per esplorare nuovi modi di usare il tricotin.
          </p>
        </div>

        <div className="mt-12 sm:mt-16 space-y-8 sm:space-y-10" data-id="element-32" data-mp="3t2j7bw061ty5">
          {bonuses.map((bonus, i) => {
          const reversed = i % 2 === 1;
          return <article key={bonus.id} className="grid md:grid-cols-2 items-center rounded-[2rem] bg-cream overflow-hidden shadow-soft" data-id="element-33" data-mp="1r8a6tp9tp9gt" data-mpi={i}>
                <div className={`aspect-square ${reversed ? 'md:order-2' : ''}`} data-id="element-34" data-mp="3icbvfymki1ph">
                  {bonus.image ? <img src={bonus.image} alt={bonus.imageAlt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-35" data-mp="3dd90x847rdvr" /> : <CoverPending title={bonus.name} data-id="element-36" data-mp="3n54zsle4j811" />}
                </div>
                <div className="p-7 sm:p-10 lg:p-14" data-id="element-37" data-mp="3n5y7bokwq1k8">
                  <p className="font-serif text-lg font-semibold text-berry-deep" data-id="element-38" data-mp="2zesjon8q64zd">
                    Bonus {bonus.number}
                  </p>
                  <h3 className="mt-2 font-serif text-2xl sm:text-3xl font-semibold text-plum leading-snug" data-id="element-39" data-mp="2uik8tm1k8xy0">
                    {bonus.name}
                  </h3>
                  <p className="mt-3 font-serif italic text-lg text-ink" data-id="element-40" data-mp="33g49asrlmq7k">{bonus.benefit}</p>
                  <p className="mt-4 text-base leading-relaxed text-ink/75 max-w-md" data-id="element-41" data-mp="np8aaetnn7i7">
                    {bonus.description}
                  </p>
                  <div className="mt-6" data-id="element-42" data-mp="it17uw0gwe50">
                    <IncludedTag data-id="element-43" data-mp="3cjppd29wr0po" />
                  </div>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}